import { render, staticRenderFns } from "./sealBorrow.vue?vue&type=template&id=3acd62e8&scoped=true&"
import script from "./sealBorrow.vue?vue&type=script&lang=js&"
export * from "./sealBorrow.vue?vue&type=script&lang=js&"
import style0 from "./sealBorrow.vue?vue&type=style&index=0&id=3acd62e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd62e8",
  null
  
)

export default component.exports